export const NAVIGATION_ITEMS_ASYNC_OPERATION = 'NAVIGATION_ITEMS_ASYNC_OPERATION'
